import React from "react";
import Navbar from "../../../Common/Navbar";
import Footer from "../../../Common/Footer";
import Sidebar from "../../../Sidebar/Sidebar";
import EditUserComp from "./Component/EditUserComp"

const EditUser =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditUserComp />
        </div>
        <Footer />
        </>
    )
}

export default EditUser

